import axiosInstance from "../axiosInstance";
import { apiEndpoints } from "../apiConfig";

const authApi = {
  login: (credentials) => axiosInstance.post(apiEndpoints.login, credentials),
  signup: (payload) => axiosInstance.post(apiEndpoints.signup, payload),
  verifyOtp: (payload) => axiosInstance.post(apiEndpoints.verifyOtp, payload),
  resendOtp: (payload) => axiosInstance.post(apiEndpoints.resendOtp, payload),
  getUserDetails: () => axiosInstance.get(apiEndpoints.getUserDetails),
  updateUser: (updatedData) =>
    axiosInstance.post(apiEndpoints.updateUser, updatedData),
  getUsersubscriptionDetails: () =>
    axiosInstance.get(apiEndpoints.getUsersubscriptionDetails),
  getDashboardData: () => axiosInstance.get(apiEndpoints.getDashboardData),
  addNotifierEmail: (payload) => axiosInstance.post(apiEndpoints.addNotifierEmail, payload),
  removeNotifierEmail: (payload) => axiosInstance.post(apiEndpoints.removeNotifierEmial, payload),
  creditHistory: () => axiosInstance.get(apiEndpoints.creditHistory),
  forgotPassword: (payload) => axiosInstance.post(apiEndpoints.forgotPassword, payload),
  resetPassword: (payload) => axiosInstance.post(apiEndpoints.resetPassword, payload),
  checkTourStatus: (id) => axiosInstance.get(apiEndpoints.checkTour.replace("{id}", id)),
  closeAppTour: (id) => axiosInstance.post(apiEndpoints.closeTour.replace("{id}", id)),
};

export default authApi;
